module.exports = __webpack_public_path__ + "img/mianhuaICON.05847b6b.png";